import { TFunction } from 'i18next'
import {
  ActionSaveType,
  AutomationRuleActionsEnum,
} from 'src/editor/shared/types/automation-rules/actions-types'

const isActionFieldEmpty = (action: ActionSaveType) => {
  switch (action.type) {
    case AutomationRuleActionsEnum.add_tag:
    case AutomationRuleActionsEnum.remove_tag: {
      return !action.tag.id
    }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
    case AutomationRuleActionsEnum.unsubscribe_from_campaign: {
      return !action.campaign.id
    }
    case AutomationRuleActionsEnum.enroll_in_course:
    case AutomationRuleActionsEnum.revoke_access_to_course: {
      return !action.course.id
    }
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle: {
      return !action.courseBundle.id
    }
    case AutomationRuleActionsEnum.send_email: {
      return !action.systemeEmail.id
    }
    case AutomationRuleActionsEnum.send_email_to_specific_address: {
      return !action.emailMessageWithRecipient.id
    }
    case AutomationRuleActionsEnum.revoke_access_to_community:
    case AutomationRuleActionsEnum.grant_access_to_community: {
      return !action.community.id
    }
    case AutomationRuleActionsEnum.send_webhook: {
      return (
        !action.webhookUrl ||
        (action.webhookUrl && action.webhookUrl.length === 0)
      )
    }
    case AutomationRuleActionsEnum.create_user: {
      return !action.locale
    }
  }
}

export const validateAutomationAction = (
  action: ActionSaveType,
  t: TFunction,
) => {
  if (isActionFieldEmpty(action)) {
    return t('validation.errors.form_field_should_not_be_empty')
  }
  return null
}
